/**
 * Created by linjianxi on 2017/1/20.
 */
import {debugUrlArr} from '../config'
let debug = process.env.NODE_ENV === 'development'
let CHONGZHI = 'http://lvbsnscdn.eastmoney.com/frontend/authentication/#/anchor/choice'                       // 跳转到充值页面
let GetRedCouponList = 'https://lvbpayment.eastmoney.com/api/MyAccount/GetRedCouponList'                      // 获取红包列表
let GetEnableCashCouponAmount = 'https://lvbpayment.eastmoney.com/api/MyAccount/GetEnableCashCouponAmount'    // 获取用户红包
let ReceiveRedCoupon = 'https://lvbpayment.eastmoney.com/api/MyAccount/ReceiveRedCoupon'                       // 激活红包
let currentUrl = window.location.origin
debugUrlArr.forEach((v) => {
  if (currentUrl === v || debug) {
    CHONGZHI = 'https://sns-qas.lvb.eastmoney.com/frontend/authentication/#/anchor/choice'
    GetRedCouponList = 'https://lvbmoneyapi-qas.eastmoney.com/api/myaccount/GetRedCouponList'
    GetEnableCashCouponAmount = 'https://lvbmoneyapi-qas.eastmoney.com/api/myaccount/GetEnableCashCouponAmount'
  }
})
export {
  CHONGZHI,
  GetRedCouponList,
  GetEnableCashCouponAmount,
  ReceiveRedCoupon
}



// WEBPACK FOOTER //
// ./src/utils/environconfig.js